import { SvgIcon, SvgIconProps } from '@mui/material';

export const BeyondTrustIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 50 65" {...props}>
    <path
      fill="#ff5500"
      d="M47.92,26.54l-5.74-5.74a.15.15,0,0,0-.17,0,.16.16,0,0,0-.09.14v40.3a.16.16,0,0,0,.09.14h.06a.16.16,0,0,0,.11,0l5.74-5.74a1.58,1.58,0,0,0,.39-1V27.5a1.61,1.61,0,0,0-.39-1"
    />
    <path
      fill="#ff5500"
      d="M37.6,17.41H17.26a.32.32,0,0,1-.31-.31V.16A.16.16,0,0,0,16.85,0a.15.15,0,0,0-.17,0L10.94,5.79a1.62,1.62,0,0,0-.4,1V23.65a.16.16,0,0,0,.16.16H31a.32.32,0,0,1-.31.31v3a.8.8,0,0,1-.8.8H10.7a.16.16,0,0,0-.11,0,.16.16,0,0,0,0,.11V49.69a4.5,4.5,0,0,0,4.5,4.5H30.54a.8.8,0,0,1,.8.8v3a.32.32,0,0,1-.31.31H15A8.66,8.66,0,0,1,6.4,49.69v-39a.16.16,0,0,0-.09-.14.15.15,0,0,0-.17,0L.39,16.33a1.63,1.63,0,0,0-.39,1V51.56A13.19,13.19,0,0,0,13.17,64.74H37.6a.16.16,0,0,0,.16-.16l0-47A.18.18,0,0,0,37.6,17.41ZM31.34,47a.8.8,0,0,1-.8.8H17.78A.8.8,0,0,1,17,47V35.16a.8.8,0,0,1,.8-.8H30.54a.8.8,0,0,1,.8.8Z"
    />
  </SvgIcon>
);
